import { useEffect, useState } from "react";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "@/components/ui/select";
import api from "@/lib/api";

const UNSET = "__unset__";
export const NOT_RECORDED = "NOT_RECORDED";

export function useBoroughOptions() {
  const [boroughs, setBoroughs] = useState([]);
  useEffect(() => { api.get("/enquiries/intake-options").then((r) => setBoroughs(r.data.boroughs || [])).catch(() => setBoroughs([])); }, []);
  return boroughs;
}

function grouped(options) {
  return options.reduce((acc, o) => { (acc[o.group] = acc[o.group] || []).push(o); return acc; }, {});
}

// Managed list only (32 boroughs, City of London separately, Outside London, Unknown). Never inferred from a postcode.
export function BoroughSelect({ id, value, onChange, options, label = "Borough", placeholder = "Not recorded", allowNotRecordedFilter = false, allLabel, className = "h-9" }) {
  const groups = grouped(options);
  return (
    <div className="space-y-1.5">
      {label && <Label htmlFor={id}>{label}</Label>}
      <Select value={value || UNSET} onValueChange={(v) => onChange(v === UNSET ? "" : v)}>
        <SelectTrigger id={id} data-testid={id} className={className}><SelectValue placeholder={placeholder} /></SelectTrigger>
        <SelectContent className="max-h-72">
          <SelectItem value={UNSET}>{allLabel || placeholder}</SelectItem>
          {allowNotRecordedFilter && <SelectItem value={NOT_RECORDED}>Not recorded</SelectItem>}
          {Object.entries(groups).map(([g, items]) => (
            <SelectGroup key={g}><SelectLabel>{g}</SelectLabel>{items.map((o) => <SelectItem key={o.code} value={o.code}>{o.label}</SelectItem>)}</SelectGroup>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
